import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

/**
 * One shared editor for every manually-editable CV/letter field. Owns only
 * its own draft text; the parent decides what field is selected and what op
 * a Save produces. Kept deliberately dumb: no HTTP, no knowledge of EditOp
 * shapes.
 */
@Component({
  selector: 'bst-field-editor',
  templateUrl: './field-editor.component.html',
  styleUrls: ['./field-editor.component.scss'],
  standalone: false,
})
export class FieldEditorComponent implements OnChanges {
  @Input() public label = '';
  @Input() public text = '';
  @Input() public maxLength = 3000;
  @Input() public busy = false;

  @Output() public save = new EventEmitter<string>();
  @Output() public cancel = new EventEmitter<void>();
  @Output() public dirtyChange = new EventEmitter<boolean>();

  public draft = '';

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['text']) {
      this.draft = this.text;
      this.dirtyChange.emit(false);
    }
  }

  public get isDirty(): boolean {
    return this.draft !== this.text;
  }

  public onInput(): void {
    this.dirtyChange.emit(this.isDirty);
  }

  public onSave(): void {
    if (!this.isDirty || this.busy) { return; }
    this.save.emit(this.draft);
  }

  public onCancel(): void {
    this.draft = this.text;
    this.dirtyChange.emit(false);
    this.cancel.emit();
  }

  public onKeydown(event: KeyboardEvent): void {
    if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
      event.preventDefault();
      this.onSave();
    } else if (event.key === 'Escape') {
      event.preventDefault();
      this.onCancel();
    }
  }
}
